import React from 'react';

const CustomFields = () => {
    return <h1>Fields</h1>;
};

export default CustomFields;
